export default "__VITE_ASSET__RwJ3G13p__"